module.exports = __webpack_public_path__ + "media/bundles/YoupiJob/assets/images/svg-icons/jobber-selection/3-d6bc9db5fb0791ad978bcf2e434608b0.svg";